<div class="er-cs">
  <h1 mat-dialog-title class="er-cs-head">Acknowledgement</h1>
  <div mat-dialog-content class="er-cs-body">
    <i class="fa fa-mobile-alt er-cs-icon" aria-hidden="true"></i>
    <p>
      This service is available on the <span class="er-cs-brand-a">EasyRin</span> mobile application
    </p>
  </div>
  <div mat-dialog-actions class="er-cs-actions">
    <button type="button" class="er-btn er-btn--primary" (click)="onNoClick()">Okay</button>
  </div>
</div>
